
const VocabVerificationScreen = {
    'verifying' : ['Verificando su correo', 'Active treatments'],
    'if_success' : ['Un momento por favor', 'Suspend'],
    'success_message' : ['Exito, te redigiremos', 'Suspend'],
    'failure_message' : ['Algo salio mal, intenta de nuevo o contacta al equipo de soporte'],
    'login_button': ['Login', 'Login'],
    'retry_button': ['Reintentar', 'Retry']
   
  }
  export default VocabVerificationScreen;